import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import type { JSX } from 'react';

import './IconButton.scss';

interface IconButtonProps {
  label: string | JSX.Element;
  beginIcon?: string;
  classNames?: string;
  buttonKey: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export const IconButton = ({
  label,
  beginIcon,
  classNames,
  buttonKey,
  onClick,
  disabled = false,
  loading,
}: IconButtonProps) => {
  return (
    <div className="of-icon-button-container">
      <CL.Button
        key={buttonKey}
        onClick={onClick}
        disabled={disabled}
        loading={loading}
        className={['of-icon-button__button', classNames].join(' ')}
        type="button"
        color="light"
        size="l"
      >
        <>
          {beginIcon && (
            <CL.Icon
              className={`of-icon-button__button__begin-button-icon ${dsClass.FONT_WEIGHT_600} ${dsClass.MARGIN_RIGHT_1}`}
              size="l"
              color="blue-600"
              icon={beginIcon}
            />
          )}
          <label className={`of-icon-button__button__label ${dsClass.FONT_WEIGHT_400} ${dsClass.DISPLAY_INLINE_BLOCK}`}>
            {label}
          </label>
        </>
      </CL.Button>
    </div>
  );
};
